<template>
  <div class="contact">
    <TextPage>
      <div class="copy-header">
        <div class="inner-copy">
          <p class="knuvu-title">Contact Information</p>
          <p class="knuvu-subtitle">KnuVu, LLC</p>
          <p>
            <a href="mailto:info@knuvu.com">info@knuvu.com</a>
          </p>
        </div>
      </div>
    </TextPage>
  </div>
</template>

<script>
import TextPage from "@/components/global/text-page.vue";
export default {
  name: "Contact",
  title: "Contact - Knuvu",
  components: {
    TextPage,
  },
};
</script>